import { settings } from '../../../settings/settings-util'

export default class ModuleLangAttrib {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer() {
        return reducer;
    }

    initialize(store) {
        this._store = store;
    }
    
    getMutator() {
        return (parameters) => {
            //this should be in the culture format 'en-US'/'de-DE'/etc

            if (typeof this._store === 'undefined') return parameters;

            let currentLang = this._store.getState()
            [this._settings.stateLocations.Conversation.Base]
            [this._settings.stateLocations.Conversation.language];

            if (typeof currentLang === 'undefined' || currentLang === '') return parameters;
            //snag only the first two char for the lang code
            currentLang = currentLang.substring(0,2);
            parameters.attributes = Object.assign({}, parameters.attributes, {
                lang: currentLang
                });
            return parameters;
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lang-attrib/src/lang-attrib.js